module.exports = __webpack_public_path__ + "img/board.be6eac8b.png";